import './support-faq.component.scss'

document.querySelectorAll('.faq-item').forEach((root) => {
  const heading = root.querySelector('.faq-item__heading')
  if (heading)
    heading.addEventListener('click', () => {
      root.classList.toggle('is-active')
    })
})
